var map = {
	"./Inter-Black.woff2": 3094,
	"./Inter-BlackItalic.woff2": 7096,
	"./Inter-Bold.woff2": 1435,
	"./Inter-BoldItalic.woff2": 3013,
	"./Inter-ExtraBold.woff2": 9225,
	"./Inter-ExtraBoldItalic.woff2": 1383,
	"./Inter-ExtraLight.woff2": 3855,
	"./Inter-ExtraLightItalic.woff2": 8529,
	"./Inter-Italic.woff2": 486,
	"./Inter-Light.woff2": 3755,
	"./Inter-LightItalic.woff2": 1584,
	"./Inter-Medium.woff2": 3117,
	"./Inter-MediumItalic.woff2": 5792,
	"./Inter-Regular.woff2": 22,
	"./Inter-SemiBold.woff2": 7550,
	"./Inter-SemiBoldItalic.woff2": 7183,
	"./Inter-Thin.woff2": 5042,
	"./Inter-ThinItalic.woff2": 4868,
	"./Inter-V.var.subset.woff2": 7279,
	"./Inter-italic.var.woff2": 6945,
	"./Inter-roman.var.woff2": 7606,
	"./Inter.var.woff2": 5525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8880;